export const PRE_APPROVAL = 'PRE_APPROVAL';
export const Pre_approval = 'Pre-approval';
export const PreApproval = 'PreApproval';
export const preApprovalRoute = 'pre-approval';
